import { render, staticRenderFns } from "./UserPosts.vue?vue&type=template&id=e09fb06c&scoped=true&"
import script from "./UserPosts.vue?vue&type=script&lang=js&"
export * from "./UserPosts.vue?vue&type=script&lang=js&"
import style0 from "./UserPosts.vue?vue&type=style&index=0&id=e09fb06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09fb06c",
  null
  
)

component.options.__file = "UserPosts.vue"
export default component.exports